import React, { Component } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { Editor } from 'react-draft-wysiwyg';
import EditorState from 'draft-js/lib/EditorState';
import convertFromHTML from 'draft-js/lib/convertFromHTMLToContentBlocks';
import ContentState from 'draft-js/lib/ContentState';
import { stateToHTML } from 'draft-js-export-html';
import Toggle from 'react-toggle';
import styles from '../../components/shared/styles';
import { RowDivision, DivisionLabel } from '../../components/shared/styled-components';
import { basicManager } from '../../../../helpers/managers';
import Colors from '../../../../styles/colors';
import {
  InputLabel,
  InputText,
  DraftEditorWrapper,
  ToggleWrapper,
  ToggleLabel,
} from '../../../../styles/styled';
import { OrangeSubmitButton } from '../../../../components/buttons/buttons';
import Loading from '../../../../components/Loading';
import { StatusContainer } from './styled';
import {
  subscriptionRequestBodyTemplate,
  subscriptionRequestSubjectTemplate,
} from '../../../../../server/scripts/helpers/emailTemplate';

const htmlToState = html => {
  const blockArray = convertFromHTML(html);
  const content = ContentState.createFromBlockArray(blockArray.contentBlocks, blockArray.entityMap);
  return EditorState.createWithContent(content);
};

export default class WhiteLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customEmailSubject: '',
      customEmailBodyEditorState: EditorState.createEmpty(),
      isCustomEmailDisabled: true,
      isCustomEmailEmpty: true,
      loading: true,
      saving: false,
    };

    this.saveTemplate = this.saveTemplate.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onTemplateStateChange = this.onTemplateStateChange.bind(this);
    this.onEmailSubjectChange = this.onEmailSubjectChange.bind(this);
  }

  componentDidMount() {
    const { userInfo } = this.props;
    const { publisher = {} } = userInfo;

    const { subscriptionEmailTemplate = {} } = publisher;
    const isCustomEmailEmpty = isEmpty(subscriptionEmailTemplate);

    const {
      disabled = isEmpty(subscriptionEmailTemplate),
      subject = subscriptionRequestSubjectTemplate(),
      body = subscriptionRequestBodyTemplate(),
    } = subscriptionEmailTemplate;

    const customEmailBodyEditorState = htmlToState(body);

    this.setState({
      isCustomEmailEmpty,
      isCustomEmailDisabled: disabled,
      customEmailSubject: subject,
      customEmailBodyEditorState,
      subscriptionEmailTemplateBak: {
        disabled,
        subject,
        body: stateToHTML(customEmailBodyEditorState.getCurrentContent()),
      },
      loading: false,
    });
  }

  saveTemplate() {
    this.setState({ saving: true }, () => {
      const {
        customEmailSubject,
        customEmailBodyEditorState,
        isCustomEmailDisabled,
        isCustomEmailEmpty,
        subscriptionEmailTemplateBak,
      } = this.state;

      const subscriptionEmailTemplate = {
        disabled: isCustomEmailDisabled,
        subject: customEmailSubject,
        body: stateToHTML(customEmailBodyEditorState.getCurrentContent()),
      };

      if (
        isCustomEmailDisabled &&
        isCustomEmailEmpty &&
        isEqual(subscriptionEmailTemplate, subscriptionEmailTemplateBak)
      ) {
        this.setState({ saving: false }, () => {
          this.props.showAlertModal({
            content: 'No need to save default template.',
            cancel: false,
          });
        });
        return;
      }

      const revisedPublisherData = {
        [`publishers/${this.props.userInfo.publisherID}/subscriptionEmailTemplate`]: subscriptionEmailTemplate,
      };

      basicManager.update(revisedPublisherData)
        .then(() => {
          this.setState({ saving: false }, () => {
            this.props.showAlertModal({
              content: 'White label data successfully saved.',
              cancel: false,
            });
          });
        })
        .catch(err => {
          this.setState({ saving: false }, () => {
            this.props.showAlertModal({
              content:
                'There was a problem saving white label data. Please contact support at support@mysoundwise.com',
              cancel: false,
            });
          });
          console.log(err);
        });
    });
  }

  onEditorStateChange(statekey) {
    return editorState => {
      this.setState({ [statekey]: editorState });
    };
  }

  onTemplateStateChange(key = 'title', value = '', cb = () => {}) {
    return () => {
      const oldstatevalue = this.state[key];
      this.setState({ [key]: value }, () => {
        cb(oldstatevalue);
      });
    };
  }

  onEmailSubjectChange(e) {
    this.setState({ customEmailSubject: e.target.value });
  }

  render() {
    const { userInfo = {} } = this.props;
    const {
      loading = true,
      saving = false,
      customEmailSubject,
      customEmailBodyEditorState,
      isCustomEmailDisabled,
    } = this.state;

    if (!('publisher' in userInfo) || loading) {
      return (
        <div className="row">
          <div className="col-md-12">
            <StatusContainer>
              <Loading text="Loading transactions" align="center" />
            </StatusContainer>
          </div>
        </div>
      );
    }

    const toggleText = isCustomEmailDisabled
      ? 'Custom subscription request template disabled'
      : 'Custom subscription request template enabled';

    const emailSybjectLabel = 'Template Subject';
    const emailBodyLabel = 'Template Body';

    return (
      <WhiteLabelWrapper>
        <WhiteLabelContainer>
          <RowDivision className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <ToggleWrapper>
                <Toggle
                  className="toggle-green"
                  aria-labelledby="toggle subscription"
                  checked={!isCustomEmailDisabled}
                  onChange={this.onTemplateStateChange(
                    'isCustomEmailDisabled',
                    !isCustomEmailDisabled
                  )}
                />
                <ToggleLabel className="text-large">{toggleText}</ToggleLabel>
              </ToggleWrapper>
            </div>
          </RowDivision>

          {!isCustomEmailDisabled && (
            <>
              <RowDivision className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <InputLabel>{emailSybjectLabel}</InputLabel>
                  <InputText
                    type="text"
                    value={customEmailSubject}
                    onChange={this.onEmailSubjectChange}
                  />
                </div>
              </RowDivision>
              <RowDivision className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <DivisionLabel>{emailBodyLabel}</DivisionLabel>
                  <div className="margin-bottom-10px">
                    <DraftEditorWrapper>
                      <Editor
                        // readOnly={!enableEmail}
                        editorState={customEmailBodyEditorState}
                        editorStyle={{ ...styles.editorStyle, height: 250 }}
                        wrapperStyle={styles.wrapperStyle}
                        onEditorStateChange={this.onEditorStateChange('customEmailBodyEditorState')}
                        stripPastedStyles={true}
                      />
                    </DraftEditorWrapper>
                  </div>
                </div>
              </RowDivision>
            </>
          )}

          <div className="row padding-bottom-20px padding-top-20px">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
              <div className="pull-left sm-float-none">
                <OrangeSubmitButton
                  label={saving ? 'Saving...' : 'Save'}
                  onClick={this.saveTemplate}
                  styles={{ margin: 0, backgroundColor: !saving ? Colors.mainOrange : '#fc9961' }}
                  className="sm-width-100"
                  disabled={saving}
                />
              </div>
            </div>
          </div>
        </WhiteLabelContainer>
      </WhiteLabelWrapper>
    );
  }
}

const WhiteLabelWrapper = styled.div`
  padding: 30px;
  background: #fff;
`;

const WhiteLabelContainer = styled.div`
  max-width: 720px;
`;
